<template>
  <div :key="model.Codigo">
    <b-card class="mb-3 mt-3">
      <core-Form ref="form">
        <b-form-row>
          <b-form-group label="Banco" class="col-3">
            <input-select
              v-model="model.banco"
              :input="changeBanco"
              :options="bancos"
              required
            />
          </b-form-group>

          <b-form-group label="Agência" class="col-3">
            <input-select
              v-model="model.agencia"
              :input="changeAgencia"
              :options="agencias"
              :required="!multiplasContas"
            />
          </b-form-group>

          <b-form-group label="Parceiro" class="col-3" v-if="multiplasContas">
            <input-select
              v-model="model.parceiro"
              :input="changeParceiro"
              :options="parceiros"
              single
              required
            />
          </b-form-group>

          <b-form-group label="Conta" class="col-3" v-if="!multiplasContas">
            <input-select
              v-model="model.conta"
              :input="changeConta"
              :search="pesquisaConta"
              :options="contas"
              :disabled="!model.agencia"
              required
            />
          </b-form-group>

          <b-form-group
            label="Modelo Conta"
            class="col-3"
            v-if="!multiplasContas"
          >
            <b-form-select
              v-model="model.modeloConta"
              :options="$api.Arrays.ModeloConta"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="Contas"
            class="col-12"
            v-if="multiplasContas">
            <b-card>
              <b-form-row class="mb-2 align-items-center">
                <b-col cols="auto" style="min-width: 200px">
                  <input-documento
                    v-model="documentoClienteFiltro"
                    placeholder="CPF/CNPJ do cliente"
                  />
                </b-col>
                <b-col cols="auto" style="min-width: 200px">
                  <input-select
                    v-model="situacaoFiltro"
                    :input="changeSituacaoFiltro"
                    :options="$api.Arrays.SituacaoConta"
                    placeholder="Todas as situações"
                    single
                  />
                </b-col>
                <b-col cols="auto">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="!selecionadas.length"
                    @click="limparSelecaoContas"
                  >
                    Limpar seleção
                  </b-button>
                </b-col>
                <b-col cols="auto">
                  {{ selecionadas.length }} conta(s) selecionada(s)
                </b-col>
              </b-form-row>
              <core-Grid2
                ref="gridContas"
                :onRead="onReadContas"
                :addOption="false"
                :editOption="false"
                :deleteOption="false"
                :filterOption="false"
                :scrollable="false"
                :pageable="true"
                serverPaging
                @checkboxChange="onCheckboxChangeConta"
                :checkboxSelectAll="onCheckboxSelectAllConta"
              >
                <template slot="gridColumns">
                  <kendo-grid-column template="checkbox" :width="40" />
                  <kendo-grid-column field="codigo" hidden></kendo-grid-column>
                  <kendo-grid-column
                    title="Conta"
                    field="contaPgto"
                    :width="100"
                  ></kendo-grid-column>
                  <kendo-grid-column
                    title="Descrição"
                    field="descricao"
                    :width="120"
                  ></kendo-grid-column>
                  <kendo-grid-column
                    title="Titular"
                    field="nomeTitular"
                    :width="150"
                  ></kendo-grid-column>
                  <kendo-grid-column
                    title="Documento Federal"
                    field="documentoFederal"
                    template="documento"
                    :width="120"
                  ></kendo-grid-column>
                  <kendo-grid-column
                    title="Situação"
                    field="situacao"
                    :values="$api.Arrays.SituacaoConta"
                    :width="90"
                  ></kendo-grid-column>
                </template>
              </core-Grid2>
            </b-card>
          </b-form-group>
        </b-form-row>


        <b-form-row v-if="!multiplasContas">
          <b-form-group label="Cliente" class="col-6">
            <b-input v-model="model.nome" disabled />
          </b-form-group>

          <b-form-group label="Documento Federal" class="col-3">
            <input-documento v-model="model.documentoFederal" disabled />
          </b-form-group>

          <b-form-group label="Tipo Pessoa" class="col-3">
            <b-form-select
              v-model="model.tipoPessoa"
              :options="$api.Arrays.TiposPessoa"
              disabled
            />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <slot name="extraBtns"></slot>
        </b-form-row>
      </core-Form>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bancos: [],
      agencias: [],
      contas: [],
      parceiros: [],
      selecionadas: [],
      limiteContasSelecionadas: 10,
      totalContasFiltradas: 0,
      situacaoFiltro: null,
      documentoClienteFiltro: null,
      firstLoadSelected: true,
    };
  },
  props: {
    value: Object,
    codigoAgenciaSelected: String,
    codigoContaSelected: String,
    numeroContaSelected: String,
    multiplasContas: { type: Boolean, default: false }
  },
  computed: {
    model: {
      get() {
        var obj = this.value;
        return obj;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    codigoContaSelected(val) {
      let th = this;
      if (val && th.codigoAgenciaSelected) {
        th.firstLoadSelected = true;
        th.model.agencia = th.agencias.find(
          (a) => a.value === th.codigoAgenciaSelected
        );
        th.changeAgencia(th.model.agencia);
      }
    },
    // Alterna único/múltiplo em runtime: reseta seleção e cabeçalho.
    multiplasContas() {
      let th = this;
      th.contas = [];
      th.selecionadas = [];
      th.model.conta = null;
      th.$set(th.model, "parceiro", null);
      th.$set(th.model, "codigosConta", []);
      th.model.codigoConta = null;
      th.model.nome = "";
      th.model.documentoFederal = "";
      th.model.tipoPessoa = null;
      th.model.modeloConta = null;

      if (th.multiplasContas) {
        if (!th.parceiros.length) th.loadComboParceiros();
        th.model.agencia = null;
      }

      // Voltou para single: recarrega contas (no múltiplo não há auto-load).
      if (!th.multiplasContas && th.model.agencia && th.model.agencia.value) {
        th.$nextTick(() => th.loadComboContas());
      }
    },
    selecionadas(val) {
      this.$set(this.model, "codigosConta", val.slice());
    },
    documentoClienteFiltro() {
      this.debouncedRefreshGridContas();
    },
  },
  created() {
    this.pesquisaConta = _.debounce(this.loadComboContas, 300);
    this.debouncedRefreshGridContas = _.debounce(() => {
      if (this.$refs.gridContas) this.$refs.gridContas.refresh();
    }, 500);
    if (!Array.isArray(this.model.codigosConta)) {
      this.$set(this.model, "codigosConta", []);
    }
    if (this.model.parceiro === undefined) {
      this.$set(this.model, "parceiro", null);
    }
    if (this.multiplasContas && !this.parceiros.length) {
      this.loadComboParceiros();
    }
  },
  methods: {
    validate() {
      return this.$api.UI.FormValidate(this.$refs.form);
    },
    onReadContas(options, search) {
      let th = this;

      if (!th.model.parceiro) {
        options.success({ data: [], total: 0 });
        return;
      }

      let dto = {
        parameters: [
          { name: "filter", value: search },
          { name: "codigoParceiro", value: th.model.parceiro },
          {
            name: "codigoAgencia",
            value: th.model.agencia ? th.model.agencia.value : null,
          },
          { name: "situacaoConta", value: th.situacaoFiltro },
          { name: "documentoCliente", value: th.documentoClienteFiltro },
        ],
      };

      th.$api.Contas.GetContaParceiroPaginado(dto, options).then((response) => {
        if (!th.$api.UI.PostLoadData(response, "", false)) {
          options.success({ data: [], total: 0 });
          return;
        }

        let data = Array.isArray(response.data) ? response.data : [];
        th.totalContasFiltradas = response.total || data.length;

        data = data.map((item) => ({
          ...item,
          selecionado: th.selecionadas.includes(item.codigo),
        }));

        options.success({ data, total: th.totalContasFiltradas });
      });
    },
    onCheckboxChangeConta(current) {
      let th = this;
      if (!current || !current.codigo) return;

      const idx = th.selecionadas.indexOf(current.codigo);

      if (current.selecionado) {
        if (idx < 0) {
          if (th.selecionadas.length >= th.limiteContasSelecionadas) {
            current.selecionado = false;
            th.desmarcarCheckboxConta(current);
            th.avisarLimiteContasSelecionadas();
            return;
          }
          th.selecionadas.push(current.codigo);
        }
      } else if (idx > -1) {
        th.selecionadas.splice(idx, 1);
      }
    },
    onCheckboxSelectAllConta() {
      let th = this;
      const pageItems = th.$refs.gridContas.dataList;
      if (!pageItems || !pageItems.length) return;

      const marcando = !!pageItems[0].selecionado;

      if (!marcando) {
        pageItems.forEach((item) => {
          const idx = th.selecionadas.indexOf(item.codigo);
          if (idx > -1) th.selecionadas.splice(idx, 1);
        });
        return;
      }

      let limiteAtingido = false;

      pageItems.forEach((item) => {
        const idx = th.selecionadas.indexOf(item.codigo);
        if (idx > -1) return;

        if (th.selecionadas.length >= th.limiteContasSelecionadas) {
          item.selecionado = false;
          th.desmarcarCheckboxConta(item);
          limiteAtingido = true;
          return;
        }

        th.selecionadas.push(item.codigo);
      });

      if (limiteAtingido) th.avisarLimiteContasSelecionadas();
    },
    desmarcarCheckboxConta(item) {
      let th = this;
      th.$nextTick(() => {
        let grid = th.$refs.gridContas && th.$refs.gridContas.$refs.grid;
        let checkbox = grid && grid.$el && item.uid
          ? grid.$el.querySelector(`tr[data-uid='${item.uid}'] .custom-grid-checkbox input`)
          : null;

        if (checkbox) checkbox.checked = false;
      });
    },
    desmarcarCheckboxCabecalho() {
      let th = this;
      let grid = th.$refs.gridContas && th.$refs.gridContas.$refs.grid;
      if (!grid || !grid.$el) return;

      let header = grid.$el.querySelector('.k-grid-header input[type="checkbox"]');
      if (header) {
        header.checked = false;
        header.indeterminate = false;
      }
    },
    limparSelecaoContas() {
      let th = this;
      th.selecionadas = [];

      const pageItems = th.$refs.gridContas ? th.$refs.gridContas.dataList : null;
      if (pageItems) {
        pageItems.forEach((item) => {
          item.selecionado = false;
          th.desmarcarCheckboxConta(item);
        });
      }

      th.desmarcarCheckboxCabecalho();
    },
    avisarLimiteContasSelecionadas() {
      this.$api.UI.ShowAlert(
        "",
        `Limite de ${this.limiteContasSelecionadas} contas por solicitação. Desmarque alguma conta para selecionar outra.`
      );
    },
    loadComboBancos() {
      let th = this;
      th.$api.Bancos.GetBancosInternos().then((data) => {
        if (Array.isArray(data)) {
          data.forEach((item) => {
            let banco = {
              value: item.codigo,
              text: item.numero + " - " + item.descricao,
            };
            th.bancos.push(banco);
            if (item.numero === process.env.VUE_APP_BANCO) {
              th.model.banco = banco;
            }
          });

          th.changeBanco(th.model.banco);
        }
      });
    },
    loadComboParceiros() {
      let th = this;
      th.$api.Parceiros.GetAll().then((response) => {
        th.parceiros = [{ value: "", text: "Selecione" }];
        if (Array.isArray(response)) {
          response.forEach((item) => {
            th.parceiros.push({
              value: item.codigo,
              text: item.nome.concat(
                " ",
                "(CNPJ: ",
                th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
                ")"
              ),
            });
          });
        }
      });
    },
    changeParceiro() {
      let th = this;
      th.selecionadas = [];
      th.totalContasFiltradas = 0;
      th.situacaoFiltro = null;
      th.documentoClienteFiltro = null;

      if (th.$refs.gridContas) {
        th.$nextTick(() => th.$refs.gridContas.refresh());
      }
    },
    changeSituacaoFiltro() {
      let th = this;
      if (th.$refs.gridContas) {
        th.$nextTick(() => th.$refs.gridContas.refresh());
      }
    },
    loadComboContas(conta) {
      let th = this;
      th.contas = [];

      if (
        th.model.agencia &&
        th.model.agencia.value
      ) {
        if (th.firstLoadSelected && th.numeroContaSelected)
          conta = th.numeroContaSelected;

        let dto = {
          parameters: [
            { name: "codigoAgencia", value: th.model.agencia.value },
            { name: "numeroConta", value: conta },
          ],
        };

        th.$api.Contas.ComboContas(dto).then((data) => {
          if (data) {
            if (!data.length || data.length === 0) {
              th.$api.UI.ShowError(
                "Erro",
                "Não foram encontradas contas com os parâmetros informados."
              );
            } else {
              data.forEach((item) => {
                th.contas.push({
                  value: item.codigo,
                  text: item.contaPgto,
                  contaPgto: th.$api.UI.Format.ContaPgto(item.contaPgto),
                  descricao: item.descricao,
                  tipoConta: item.tipoConta,
                  numero: item.numero,
                  digito: item.digito,
                });
              });
              if (th.codigoContaSelected && th.firstLoadSelected) {
                th.model.conta = th.contas.find(
                  (e) => e.value === th.codigoContaSelected
                );
                th.changeConta(th.model.conta);
                th.firstLoadSelected = false;
              }
            }
          }
        });
      }
    },
    changeBanco() {
      let th = this;
      let val = th.model.banco;

      if (!val) return;

      th.agencias = [];
      th.model.agencia = null;
      th.$set(th.model, "parceiro", null);
      th.changeParceiro();
      th.changeAgencia(null);

      if (val) {
        th.model.codigoBanco = val.value;
        let dto = {
          parameters: [{ name: "codigoBanco", value: val.value }],
        };
        th.$api.Agencias.GetAll(dto)
          .then((data) => {
            if (th.multiplasContas) th.agencias.push({ value: "", text: "Selecione" });

            if (data) {
              if (!data.length || data.length === 0) {
                th.$api.UI.ShowError(
                  "Erro",
                  "Não existem agências cadastradas para este banco."
                );
              } else {
                data.forEach((item) => {
                  th.agencias.push({
                    value: item.codigo,
                    text: item.numero + "-" + item.digito + " " + item.nome,
                    numero: item.numero,
                    digito: item.digito,
                  });
                });
              }
            }
          })
          .then(() => {
            if (th.multiplasContas) return;

            th.$api.Agencias.GetCodigoAgenciaPadrao().then((data) => {
              if (data && data.length > 0) {
                var agenciaPadrao = th.agencias.find((ag) => {
                  return ag.value === data;
                });
                if (agenciaPadrao !== undefined) {
                  th.model.agencia = agenciaPadrao;
                  th.changeAgencia(agenciaPadrao);
                }
              }
            });
          });
      }
    },
    changeAgencia(val) {
      let th = this;
      let parceiroAtual = th.model.parceiro;
      th.model.conta = null;
      th.contas = [];

      if (val) {
        th.model.codigoAgencia = val.value;
        th.model.agenciaPagador = val.text;
      }

      if (th.multiplasContas) {
        th.$nextTick(() => {
          th.model.parceiro = parceiroAtual;
          if (th.$refs.gridContas) th.$refs.gridContas.refresh();
        });
        return;
      }

      th.$nextTick(() => {
        th.loadComboContas();
      });
    },
    changeConta(val) {
      let th = this;
      th.model.nome = "";
      th.model.documentoFederal = "";
      th.model.tipoPessoa = null;
      th.model.modeloConta = null;

      if (val) {
        th.model.codigoConta = val.value;
        th.model.contaPagador = val.text;

        let dto = {
          parameters: [{ name: "codigoConta", value: val.value }],
        };

        th.$api.Parceiros.GetParceiroPorConta(th.model.codigoConta).then(
          (data) => {
            th.model.parceiroNome = data.parceiroNome;
          }
        );

        th.$api.ContaCorrentistas.GetAll(dto).then((data) => {
          if (Array.isArray(data)) {
            data.forEach((item) => {
              if (item.titularidade === 1) {
                th.model.nome = item.nome;
                th.model.details = item;
                th.model.documentoFederal = th.$api.UI.Format.DocumentoFederal(
                  item.documentoFederal
                );
                th.model.tipoPessoa = item.tipoPessoa;
                th.model.modeloConta = item.modeloConta;
                th.model = Object.assign({}, th.model);
              }
            });
          }
        });
      }
    },
  },
  beforeMount() {
    this.loadComboBancos();
  },
};
</script>
